module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/home-slides/ig-08-b3beabb2e68495d0463e260d0ed424f9.jpg";